const findSelectedValue = (choices) => {
    const selected = choices.find((choice) => choice.isSelected);
    return selected && selected.value;
};
const serializeChoices = (choices) => choices.filter((choice) => choice.isSelected).map((choice) => ({ number: choice.number, value: choice.value }));
const findAllSelectedValues = (choices) => choices.filter((choice) => choice.isSelected).map((choice) => choice.value);
export const serializeField = (fieldData) => {
    if (!fieldData) {
        return { id: null };
    }
    const { id, type, choices, label, inputName, getValue } = fieldData;
    const inputNameVal = inputName || label;
    switch (type) {
        case 'radio':
        case 'select':
            return { id, inputName: inputNameVal, value: findSelectedValue(choices) };
        case 'multiselect':
            return { id, inputName: inputNameVal, value: findAllSelectedValues(choices) };
        case 'checkbox':
            return { id, inputName: inputNameVal, choices: serializeChoices(choices) };
        case 'consent':
            return { id, inputName: inputNameVal, choices: serializeChoices(choices) };
        default:
            return { id, inputName: inputNameVal, value: getValue() };
    }
};
export const serializeForm = ({ fields }) => ({
    fields: fields.map(serializeField).filter((data) => data.value !== null || !!data.choices)
});
//# sourceMappingURL=serializer.js.map